import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';

import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
  GetMorePublicPublications,
  GetPublicPublications,
  GetPublicPublicationsWidget,
} from 'app/redux/actions/publication.actions';
import { Observable } from 'rxjs';
import {
  DEAFULT_IMAGE_ENTITY,
  DEAFULT_IMAGE_PUBLICATION,
  DEAFULT_SHIELD_TEAM,
  TYPE_ALIGN_CENTER,
  TYPE_ALIGN_LEFT,
  TYPE_ALIGN_RIGHT,
  TYPE_COMPETITION_TEAM,
} from '@shared/constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EntityState } from 'app/redux/state/entity.state';
import { Entity } from 'app/graphql/interfaces/entityModel';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TypeService } from 'app/graphql/services/type.service';
import { Match, Publication, PublicEntity } from 'app/graphql/types';
import { PublicationState } from 'app/redux/state/publication.state';
import { SharedService } from '@shared/services/shared.service';
import { GetPublicMatchesWidget } from 'app/redux/actions/matches.actions';
import { MatchState } from 'app/redux/state/matches.state';
@Component({
  selector: 'app-widget-banners',
  styleUrls: ['./banners.component.scss'],
  templateUrl: './banners.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetBannersComponent implements OnInit, AfterViewInit {
  @Input() home: Boolean;
  @Input() onlyBig: Boolean;
  entity: PublicEntity = this.store.snapshot().Entity.entity;
  safeHtmlContent: SafeHtml;

  TYPE_ALIGN_CENTER = TYPE_ALIGN_CENTER;
  TYPE_ALIGN_LEFT = TYPE_ALIGN_LEFT;
  TYPE_ALIGN_RIGHT = TYPE_ALIGN_RIGHT;
  private scriptsLoaded = new Set<number>();
  constructor(
    private store: Store,
    public sharedService: SharedService,
    public typeService: TypeService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.runScripts();
  }

  runScripts() {
    const banners = this.elementRef.nativeElement.querySelectorAll('.banner-description');

    banners.forEach((banner: HTMLElement) => {
      const scripts = banner.querySelectorAll('script');

      Array.from(scripts).forEach(script => {
        const newScript = document.createElement('script');
        newScript.type = script.type ? script.type : 'text/javascript';

        if (script.src) {
          newScript.src = script.src;
          newScript.async = script.async || true;
          newScript.charset = script.charset || 'utf-8';
        } else {
          newScript.text = script.text;
        }

        script.parentNode?.replaceChild(newScript, script);
      });
    });
  }

  /*   ngAfterViewInit() {
    const scripts = this.elementRef.nativeElement.getElementsByTagName('script');
    for (let script of scripts) {
      const newScript = this.renderer.createElement('script');
      newScript.text = script.text;
      this.renderer.appendChild(script.parentNode, newScript);
      this.renderer.removeChild(script.parentNode, script);
    }
  }
 */

  getSanitizedHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
